
import { useEffect } from 'react';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory, useLocation, useParams } from 'react-router-dom';
import { Button, Loading, NavMenu } from '../../../components';
import { formatToCurrency } from '../../../utils/Currency';
import { DisplayUtils } from '../../../utils';
import './WalletDetail.scss';
import { useParametrics } from '../../../contexts/ParametricsContext';
import TransactionList from '../../../components/transactions/transactionList/TransactionList';

const WalletDetail = () => {

  const { t } = useTranslation();
  const history = useHistory();
  const location = useLocation();
  const { convocationId } = useParametrics();

  const [show, setShow] = useState(false);
  const [loading, setLoading] = useState(true);
  const [balance, setBalance] = useState(0);
  const [title, setTitle] = useState(null);

  const { petitionId, wallet } = useParams();

  useEffect(() => {
    if (!convocationId) return;
    const state = location.state;
    if(!state || !state.title) {
      history.goBack();
      return;
    }
    setBalance(state.balance);
    setTitle(state.title);
    setLoading(false);
    setShow(true);
  }, [convocationId]); // eslint-disable-line

  return (
    <NavMenu>
      {show && (
        loading ? (
          <div className="vh-100 d-flex justify-content-center align-items-center">
            <Loading />
          </div>
        ) : (
          <div className="WalletDetail">
            {DisplayUtils.isMobile() && (
              <>
                <div className="WalletDetail__content__head">
                  <Button
                      icon="/misc/icons/arrow-left-blue.svg"
                      action={() => history.goBack()}
                      className="Button__transparent"
                      styles={{width: '50px'}}
                  />
                  <h1>{title}</h1>
                  <button
                  className='button-only-icon me-2'
                    onClick={() => {
                      history.push({ pathname: `/petitions/${petitionId}/transactions/${wallet}/filters`, state: { filters: true } });
                    }}
                  >
                    <img
                      className="WalletDetail__content__head__filters"
                      src="/misc/icons/filters.png"
                      alt="filters"
                    />
                  </button>
                </div>
                <div className="WalletDetail__content__balance">
                  <div className='WalletDetail__content__balance__balance-container'>
                    <span>{t('Transactions.youHaveLeft')}</span>
                    <div className="WalletDetail__content__balance__balance-container__amount">
                      {formatToCurrency(balance)}
                    </div>
                    <span>{title}</span>
                  </div>
                </div>
              </>
            )}
            <div className='WalletDetail__content'>
              {!DisplayUtils.isMobile() && (
                <>
                  <div className="WalletDetail__content__head">
                    <Button
                        icon="/misc/icons/arrow-left-blue.svg"
                        action={() => history.goBack()}
                        className="Button__transparent"
                        styles={{width: '50px'}}
                    />
                    <h1>{title}</h1>
                    <div style={{width: '50px'}}></div>
                  </div>
                  <div className="WalletDetail__content__balance">
                    <div className='WalletDetail__content__balance__balance-container'>
                      <span>{t('Transactions.youHaveLeft')}</span>
                      <div className="WalletDetail__content__balance__balance-container__amount">
                        {formatToCurrency(balance)}
                      </div>
                      <span>{title}</span>
                    </div>
                  </div>
                </>
              )}
              <TransactionList petitionId={petitionId} wallet={wallet} />
            </div>
          </div>
        )
      )}
    </NavMenu>
  );
}

export default WalletDetail;
